module.exports = __webpack_public_path__ + "studentsi-f3ec7595.webp";